import { Component, useRef, memo } from "react";
import Popup from "../../../components/popup";
import Container from "../../../layouts/containers/container";
import Row from "../../../components/row";
import { ButtonCancel, ButtonClose, ButtonProceed, ButtonNext, ButtonPrevious, ButtonCloseCross } from "../../../components/buttons";
import PopupContext from "../../../context/context-popup";
import List from "../../../components/list";
import confetti from "canvas-confetti";
import classNames from "classnames";
import { TransitionGroup } from 'react-transition-group'

import 'animate.css';

const Wrapper = ({ current, previous, children }) => {
    const ref = useRef(null);

    const className = classNames({
        'animate__animated animate__faster': true,
        'animate__fadeInRight': current < previous,
        'animate__fadeInLeft': current > previous,
        'animate__fadeIn': current === previous
    })

    const MemoComponent = memo(() => {
        return (
            <div className={className} ref={ref}>
                { children }
            </div>
        )
    })

    return <MemoComponent/>
}

export default class PopupsOnboarding extends Component {
    static contextType = PopupContext;

    constructor(props) {
        super(props);

        this.tabs = [
            {
                title: 'Getting Started',
                component: () => {
                    return (
                        <List gap="20px">
                            <img rel="preload" src="/assets/SVG/onboarding/screen-1.png" style={{ width: '100%' }}/>
                            <List gap="5px">
                                <Container.Text fontSize="20px" color="#1976F8">Welcome to the MyDMC Onboarding</Container.Text>
                                <Container.Text fontSize="16px" color="#24191F">Your digital hub for experiencing all the great things we have to offer here at the DMC. Dive into our world tailored for doers, makers, and creators. From co-working to events, meeting rooms to memberships - access all our services in one place when it suits you.</Container.Text>
                            </List>
                        </List>
                    )
                },
            },
            {
                title: 'Getting Started',
                component: () => {
                    return (
                        <List gap="20px">
                            <img src="/assets/SVG/onboarding/screen-2.png" style={{ width: '100%' }}/>
                            <List gap="5px">
                                <Container.Text fontSize="20px" color="#1976F8">Set up your account</Container.Text>
                                <Container.Text fontSize="16px" color="#24191F">Boost collaboration by adding your team and assigning roles effortlessly. Your ‘My Account’ area is the place to manage everything right down to your password and booking information.</Container.Text>
                            </List>
                        </List>
                    )
                },
            },
            {
                title: 'Getting Started',
                component: () => {
                    return (
                        <List gap="20px">
                            <img src="/assets/SVG/onboarding/screen-3.png" style={{ width: '100%' }}/>
                            <List gap="5px">
                                <Container.Text fontSize="20px" color="#1976F8">Choose a membership or Pay-As-You-Go</Container.Text>
                                <Container.Text fontSize="16px" color="#24191F">Select monthly memberships with credits or pay as you go. You will need to register for a SAP number to process BACS payments during your first booking/membership signup for a seamless experience. Existing tenants can enjoy exclusive perks with your office space membership! </Container.Text>
                            </List>
                        </List>
                    )
                },
            },
            {
                title: 'Getting Started',
                component: () => {
                    return (
                        <List gap="20px">
                            <img src="/assets/SVG/onboarding/screen-4.png" style={{ width: '100%' }}/>
                            <List gap="5px">
                                <Container.Text fontSize="20px" color="#1976F8">Book your Co-Working Space</Container.Text>
                                <Container.Text fontSize="16px" color="#24191F">Discover your spot in our stunning co-working space across our DMC spaces. Immerse yourself in a community of like-minded trailblazers and innovators. Simply search the calendar for the latest availability from AM and PM sessions, and you can roll up and get to work in a wonderful, driven and friendly space in no time!</Container.Text>
                            </List>
                        </List>
                    )
                },
            },
            {
                title: 'Getting Started',
                component: () => {
                    return (
                        <List gap="20px">
                            <img src="/assets/SVG/onboarding/screen-5.png" style={{ width: '100%' }}/>
                            <List gap="5px">
                                <Container.Text fontSize="20px" color="#1976F8">Get tickets for our Events</Container.Text>
                                <Container.Text fontSize="16px" color="#24191F">Book brilliant DMC events with a few clicks. Tailor guest lists, dietary preferences, and more effortlessly. We have lots of events suitable for start-ups, SMEs, large enterprises, and the wider community, here at the DMC.</Container.Text>
                            </List>
                        </List>
                    )
                },
            },
            {
                title: 'Getting Started',
                component: () => {
                    return (
                        <List gap="20px">
                            <img src="/assets/SVG/onboarding/screen-6.png" style={{ width: '100%' }}/>
                            <List gap="5px">
                                <Container.Text fontSize="20px" color="#1976F8">Host your next Meeting</Container.Text>
                                <Container.Text fontSize="16px" color="#24191F">Explore meeting rooms of all sizes. Check availability and add extras, from catering to tech, with ease. You can add your guests to ensure they’re greeted on arrival at the DMC and our team will help make them feel at home before you kick start your meeting.</Container.Text>
                            </List>
                        </List>
                    )
                },
            },
            {
                title: 'Getting Started',
                component: () => {
                    return (
                        <List gap="20px">
                            <img src="/assets/SVG/onboarding/screen-7.png" style={{ width: '100%' }}/>
                            <List gap="5px">
                                <Container.Text fontSize="20px" color="#1976F8">Chat with us anytime</Container.Text>
                            </List>
                        </List>
                    )
                },
            },
            {
                title: 'Getting Started',
                component: () => {
                    return (
                        <List gap="20px">
                            <img src="/assets/SVG/onboarding/screen-8.png" style={{ width: '100%' }}/>
                            <List gap="5px">
                                <Container.Text fontSize="20px" color="#1976F8">Start exploring and booking!</Container.Text>
                                <Container.Text fontSize="16px" color="#24191F">Head to the dashboard and kickstart your myDMC adventure. Your next big move awaits!</Container.Text>
                            </List>
                        </List>
                    )
                },
            },
        ]

        this.state = {
            selectedTab: 0,
            previousSelectedTab: 0,
            ready: false,
        }

        this.popup = null;
    }

    componentDidMount() {
        // This is to cache the image so it can be rendered on the popup instantly

        const img = new Image();
        img.src = "/assets/SVG/awesome-dmcmyDMC - dark background.svg";

        img.onload = () => {
            this.setState({ ready: true }, () => {
                this.confetti()
            })
        }

        this.onKeyListener();
    }

    onKeyListener() {
        document.addEventListener('keydown', ({ key }) => {
            if (key === 'ArrowLeft') {
                const disabled = this.state.selectedTab === 0;

                if (!disabled) return this.previous();
            }

            if (key === 'ArrowRight') return this.next();
        });
    }

    confetti() {
        const duration = 0.5 * 1000;
        const end = Date.now() + duration;

        const wrapper = confetti.create(document.getElementById('canvas'), {
            resize: true,
        });

        const rect = document.querySelector('.popup__inner')?.getBoundingClientRect();

        (function frame() {
            wrapper({
                particleCount: 5,
                startVelocity: 30,
                angle: -180,
                spread: 100,
                origin: {
                    x: (rect.x / window.innerWidth) + 0.05,
                    y: (rect.y / window.innerHeight) + 0.02,
                },
                colors: ['#E34D17'],
                gravity: 0.5,
            });

            wrapper({
                particleCount: 5,
                startVelocity: 30,
                angle: 0,
                spread: 100,
                origin: {
                    x: (rect.right / window.innerWidth) - 0.05,
                    y: (rect.y / window.innerHeight) + 0.02,
                },
                colors: ['#E34D17'],
                gravity: 0.5,
            });

            if (Date.now() < end) {
                requestAnimationFrame(frame);
            }
        }());
    }

    next() {
        const { closePopup } = this.context;
        const onLastPage = this.state.selectedTab + 1 === this.tabs?.length;

        if (onLastPage) return closePopup();

        this.setState({ selectedTab: this.state.selectedTab + 1, previousSelectedTab: this.state.selectedTab })
    }

    previous() {
        this.setState({ selectedTab: this.state.selectedTab - 1, previousSelectedTab: this.state.selectedTab })
    }

    render() {
        if (!this.state.ready) return null;

        const tab = this.tabs?.[this.state.selectedTab];

        return (
            <>
                <Popup className={`popup__center popup__onboarding screen-${this.state.selectedTab}`}>
                    <canvas id="canvas"/>

                    <Popup.Header>
                        <Row gap="10px" justifyContent="space-between" alignItems="center">
                            {/* <Row gap="15px" alignItems="center">
                                <Container.Icon src="/assets/SVG/awesome-dmcmyDMC - dark background.svg" className="popup__logo"/>
                                <Container.Text fontSize="25px" className="animate__animated animate__shakeX">🎉</Container.Text>
                            </Row> */}
                            <Container.Text fontSize="20px" color="#1976F8" className="animate__animated animate__shakeX">{ tab?.title }</Container.Text>
                            <ButtonCloseCross mobile onClick={this.context.closePopup}/>
                        </Row>
                    </Popup.Header>

                    <Popup.Content>
                        <Wrapper current={this.state.current} previous={this.state.previous}>
                            { tab?.component() }
                        </Wrapper>
                    </Popup.Content>

                    <Popup.Buttons>
                        <Row className="popup-onboarding__bottom" justifyContent="space-between" alignItems="center" wrap fill>
                            <Row className={'popup-onboarding__button-wrapper'} gap="5px">
                                {
                                    this.state.selectedTab !== 0 &&
                                    <button onClick={this.previous.bind(this)} disabled={this.state.selectedTab === 0}
                                            className="popup-onboarding__button">
                                        <svg xmlns="http://www.w3.org/2000/svg" width="18.349" height="17.702"
                                             viewBox="0 0 18.349 17.702">
                                            <path id="Path_458" data-name="Path 458"
                                                  d="M14.211,17.959l6.1-6.151,1.609,1.622-8.851,8.92-8.851-8.92,1.609-1.622,6.1,6.151V4h2.276Z"
                                                  transform="translate(22.349 -4.222) rotate(90)" fill="#00c8c3"/>
                                        </svg>
                                        Previous
                                    </button>
                                }


                                <button onClick={this.next.bind(this)} class="popup-onboarding__button">
                                    {this.state.selectedTab + 1 === this.tabs?.length ? 'Get Started!' : 'Next'}
                                    <svg xmlns="http://www.w3.org/2000/svg" width="18.349" height="17.702"
                                         viewBox="0 0 18.349 17.702">
                                        <path id="Path_458" data-name="Path 458"
                                              d="M14.211,17.959l6.1-6.151,1.609,1.622-8.851,8.92-8.851-8.92,1.609-1.622,6.1,6.151V4h2.276Z"
                                              transform="translate(-4 21.924) rotate(-90)" fill="#00c8c3"/>
                                    </svg>
                                </button>
                            </Row>

                            { this.state.selectedTab !== 0 && <Container.Text fontSize="20px" color="#FF6933">{ this.state.selectedTab }/{ this.tabs?.length - 1 }</Container.Text> }
                        </Row>
                    </Popup.Buttons>
                </Popup>
            </>
        )
    }
}
